import {makeAutoObservable} from 'mobx'
import CodeObject from 'src/entities/CodeObject'

export default class StudentReport {
  id: number

  firstName?: string

  lastName?: string

  indificationNo?: string

  passport?: string

  street?: string

  houseNumber?: string

  city?: string

  phone?: string

  learningShiftId?: number

  learningShift?: CodeObject

  // The raw text the institution typed in the shift cell — shown (highlighted) when the value
  // didn't match a valid shift, so the reviewer sees what was written (e.g. "אב").
  rawLearningShift?: string

  learnLocation?: string

  scholarship?: number

  rawScholarship?: string

  framework?: string

  notes?: string

  institutionId?: number

  isApprove?: boolean

  // Set when a reviewer pulled this row out of the report so it stops blocking approval. Removed rows
  // aren't imported as students, but stay available in the "removed" list to fix and restore.
  isRemoved?: boolean

  loadStatuses?: string

  excelReportId?: number

  statusesList?: number[]

  studentImportStatuses?: CodeObject[]

  // The original value of every cell as first parsed from the institution's file, kept so the
  // reviewer can always see "what was originally written" per column even after correcting a value.
  original?: Record<string, string>

  constructor(
    report: any,
    learningShifts: CodeObject[],
    studentImportStatuses: CodeObject[]
  ) {
    this.id = report.Id
    this.firstName = report.FirstName
    this.lastName = report.LastName
    this.indificationNo = report.IndificationNo
    this.passport = report.Passport
    this.phone = report.Phone
    this.learningShiftId = report.LearningShiftId
    this.learningShift = learningShifts?.find(
      l => l.id === report.LearningShiftId
    )
    this.rawLearningShift = report.RawLearningShift
    this.learnLocation = report.LearnLocation
    this.houseNumber = report.HouseNumber
    this.scholarship = report.Scholarship
    this.rawScholarship = report.RawScholarship
    this.framework = report.Framework
    this.notes = report.Notes
    this.institutionId = report.InstitutionId
    this.isApprove = report.isApprove
    this.isRemoved = report.IsRemoved ?? false
    this.loadStatuses = report.LoadStatuses
    this.excelReportId = report.ExcelReportId
    this.city = report.City
    this.street = report.Street
    this.statusesList = report.StatusesList
    this.studentImportStatuses = studentImportStatuses?.filter(s =>
      (report.StatusesList as number[]).includes(s.id)
    )
    try {
      this.original = report.OriginalSnapshot
        ? JSON.parse(report.OriginalSnapshot)
        : undefined
    } catch {
      this.original = undefined
    }

    makeAutoObservable(this)
  }
}
